<template>
  <b-alert v-if="!user.phone && !isOfflineVersion && !isHidden" :show="!user.phone && !isOfflineVersion && !isHidden" variant="warning" dismissible
           @dismissed="hideNotificationForOneDay"
  >
    {{ $t('pages.profile.profile.missingPhone') }}
    <b-button class="p-0 ml-2 -tw-mt-1" variant="link" @click="$router.push('/user')"><strong>
      {{ $t('pages.profile.profile.edit') }}
    </strong></b-button>
  </b-alert>

</template>
<script>
import {HIDDEN_PHONE_NUMBER} from "@utils/storageKeys";
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),

    isHidden() {
      const hiddenTime = localStorage.getItem(HIDDEN_PHONE_NUMBER)
      return +hiddenTime > new Date().getTime()
    },
  },

  methods: {
    hideNotificationForOneDay() {
      localStorage.setItem(HIDDEN_PHONE_NUMBER, (new Date().getTime() + 86400000).toString())
    }
  }
}
</script>
